import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">最新快讯</h2>
          <span className="flex items-center gap-1.5 text-xs text-accent-500 ml-2">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            实时更新
          </span>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden md:block"></div>
          <div className="space-y-0">
            {updatesData.map((item, index) => (
              <div key={item.id} className="relative flex gap-5 pb-8 last:pb-0">
                <div className="hidden md:flex shrink-0 flex-col items-center">
                  <div className="w-[38px] h-[38px] rounded-full bg-primary-500 flex items-center justify-center z-10">
                    <i className="ri-flashlight-line text-white text-sm"></i>
                  </div>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl p-5 md:ml-1 border border-background-200/60 hover:border-primary-200/60 transition-colors duration-200">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">
                      {item.date} {item.time}
                    </span>
                    <span className="hidden sm:block text-foreground-300">·</span>
                    <span className={`inline-block px-2 py-0.5 text-[11px] font-medium rounded-full whitespace-nowrap ${
                      item.tag === '独家'
                        ? 'bg-accent-100 text-accent-700'
                        : item.tag === '爆料'
                        ? 'bg-primary-100 text-primary-700'
                        : item.tag === '热门' || item.tag === '热议'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-background-200 text-foreground-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-lg text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}